module.exports = __webpack_public_path__ + "static/media/contentIntroduction2.bbdcf62b.png";